import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  base: (active) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1040,
    width: '100%',
    height: '100%',
    backgroundColor: active ? colors['overlayBackground'] : 'transparent',
    transition: 'background-color .15s linear',
    pointerEvents: 'none',
  }),
});
